const Kategoriya3311 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
                <h3 className="text-center text-primary">
                    3-sinf 3-chorak<br />
                    Mavzu: Ot, sifat<br />
                    "Eng oson" bo'limidagi topshiriqlar va ularni o'tkazish metodikasi
                </h3>
                <b>1-mashq. Nuqtalar o'rniga mazmunga mos so'zni qo'ying.</b><br />
                <i>Ta'limiy maqsad:</i> O'quvchilarning gap tuzish haqidagi ko'nikmalarini rivojlantirish.<br />
                <i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa<br />
                Komiljon … eshigini ochdi va onasi tayyorlab qo'ygan … (sendvich, muzqaymoq, kotlet)ni oldi.<br />
                Soat … faqat oldinga harakatlanadi.
                <p><b>2-mashq. Juftlikda ishlang. Tartibsiz berilgan so'zlardan gaplar hosil qiling.</b></p>
                <p><i>Ta'limiy maqsad:</i> O'quvchilarning gap bo'laklari haqidagi ko'nikmalarini rivojlantirish.</p>
                <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
                <p>xushsurat/ inson/ bo'ladi/ onam/ bu</p>
                <p>________________________________________________________________</p>
                <p>o'z/ oladi/ aqlli/ ertami-kechmi/ tan/ aybini/ odam</p>
                <p>______________________________________________________________</p>
                <p><b>3-mashq. Iboralarning ma'nosini izohlang va ular ishtirokida gap tuzing.</b></p>
                <p><i>Ta'limiy maqsad:</i> O'quvchilarning gap bo'laklari haqidagi ko'nikmalarini rivojlantirish.</p>
                <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
                <p>Fig'oni falakka chiqdi - __________________________________________</p>
                <p>____________________________________________________________</p>
                <p>Adi-badi aytishdi - _____________________________________________</p>
                <p>______________________________________________________________</p>
        </div>
    )
}
export default Kategoriya3311;